/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [C3c §11a] HAS THIS DRAFT BEEN EDITED SINCE IT WAS LOADED? — the gate on Publish.
 *
 *  ⚠️ THERE WAS NO DIRTY TRACKING ON THIS PAGE AT ALL, and Publish carried no `disabled`.
 *  `publishPolicyVersion` freezes the STORED draft, so an operator who edited and then pressed
 *  Publish shipped the version WITHOUT their edit — silently, with the screen still showing it.
 *  Disabling Publish while there is something unsaved is the whole of the fix; the server did
 *  not need changing, because it was already doing the correct thing with what it had.
 *
 *  ⚠️ IT IS NOT `ArrangementBuilder`'s MACHINERY, AND MUST NOT BECOME IT. That page carries
 *  `markDirty`/`dirtyRef`/`editSeq`/`sentSeq` because it AUTOSAVES: it needs a ref readable
 *  inside a `focusout` before React has re-rendered, and a sequence number so a save cannot
 *  clear an edit it did not carry. This page has one explicit Save button and none of that.
 *  Copying it would import five facts to answer one question.
 *
 *  ⚠️ AND IT IS DRIVEN BY `Form.useWatch`, NEVER `onValuesChange`. [C2b §8c] measured that
 *  rc-field-form does NOT fire `onValuesChange` for `setFieldValue`, and this page writes
 *  PROGRAMMATICALLY at three sites — `dropArchivedColumns` (twice) and the copy-command-roles
 *  modal's `onPick`. A gate built on `onValuesChange` would therefore FAIL OPEN on exactly the
 *  edits that matter most: the ones the operator did not type.
 *
 *  ⚠️ BOTH SIDES ARE NORMALISED BY `toDraft` AT THE CALL SITE, AND THAT IS DELIBERATE. It is
 *  total, idempotent, and returns only strings, booleans and arrays, so passing the SERVER's
 *  copy through it too guarantees identical KEY ORDER and identical filtering — one normaliser
 *  rather than two expressions of one shape. (`asRoles` conditionally leads with `key`, so
 *  comparing an un-normalised `initialValues` would report a phantom edit on first render.)
 *
 *  ⚠️ IT IS GENERIC RATHER THAN IMPORTING `PolicyDraft`, so this module has no dependency on
 *  `index.tsx` at all — which is what keeps it a pure unit with its own test, `publishControl.ts`'s
 *  shape, rather than a circular import between a page and its own gate. The single type
 *  parameter is what stops the two arguments drifting to different shapes.
 *
 *  ⚠️ AND `JSON.stringify` IS PROVABLY SAFE ON THIS EXACT VALUE, rather than generally.
 *  rc-field-form already `JSON.stringify`s the selected value to decide whether to re-render,
 *  and this page's own header records that `toDraft` was written to be serialisable FOR THAT
 *  REASON. This reuses a property the page already depends on; it does not assume a new one.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
export const policyIsDirty = <T>(draft: T, saved: T): boolean => JSON.stringify(draft) !== JSON.stringify(saved);
